import moment from "moment";
import axios from "../api/axios";
import { open_dialog_warning } from "../utils/dialog_swal2/alart_one_line";

const getCsrfToken = async () => {
  await axios.get(`/sanctum/csrf-cookie`);
};

export async function handlelogout() {
  try {
    await getCsrfToken();
    const res = await axios.post("/logout");

    if (res.data.status === "success") {
      localStorage.clear();
      window.location.href = "/login";
    }
  } catch (e) {
    localStorage.clear();
    window.location.href = "/login";
    console.error("Logout failed: ", e.response?.data);
  }
}

// เช็คค่าข้อมูลผู้ใช้
export async function handleCheckUpdate(userData) {

  if (!userData.user_nickname) {
    const res = await open_dialog_warning('มีการอัพเดตฟีเจอร์ใหม่ กรุณาลงชื่อเข้าใช้ใหม่อีกครั้ง');
  
    if (res) {
      handlelogout();
    }
  }
}
